import http from './http.service';

class AppSettingsService {
    constructor() {
        this.$http = http;
        this.baseUrl = "/api/applicationSettings";
    }

    getAppUserSettings() {
        return this.$http.get(`${this.baseUrl}/appUserSettings`);
    }

    getAppsettingsData() {
        return this.$http.get(`${this.baseUrl}/appsettingsData`);
    }

    saveAppUserSettings(model) {
        return this.$http.post(`${this.baseUrl}/saveAppUserSettings`, model);
    }

    getAppEventSettings() {
        return this.$http.get(`${this.baseUrl}/appEventSettings`);
    }

    saveAppEventSettings(model) {
        return this.$http.post(`${this.baseUrl}/saveAppEventSettings`, model);
    }

    getAppIsupoSettings() {
        return this.$http.get(`${this.baseUrl}/appIsupoSettings`);
    }

    saveAppIsupoSettings(model) {
        return this.$http.post(`${this.baseUrl}/saveAppIsupoSettings`, model);
    }

    getAppSigningSettings() {
        return this.$http.get(`${this.baseUrl}/appSigningSettings`);
    }

    saveAppSigningSettings(model) {
        if (!model) {
            return Error('Невалиден модел');
        }

        return this.$http.post(`${this.baseUrl}/saveAppSigningSettings`, model);
    }

    getAppFormSettings() {
        return this.$http.get(`${this.baseUrl}/appFormSettings`);
    }

    saveAppFormSettings(model) {
        return this.$http.post(`${this.baseUrl}/saveAppFormSettings`, model);
    }
}

export default new AppSettingsService();
